import { render } from "./GotMsg.vue?vue&type=template&id=1091b146"
import script from "./GotMsg.vue?vue&type=script&lang=js"
export * from "./GotMsg.vue?vue&type=script&lang=js"

import "./GotMsg.vue?vue&type=style&index=0&id=1091b146&lang=css"
script.render = render

export default script